import React, { memo, useEffect, useState } from 'react'

import {
   Input,
   DateInput,
   Dropdown,
} from '../../form/fields'
import { formatDateForDisplay, parseDate } from '../../../../utils/datetime'
import DropdownWrapper from '../dropdownWrapper'

import { OtherProps } from './types'
import * as styles from '../crudItems.module.scss'

const Other = ({
   activeValue,
   itemForm,
   updateForm,
   updateFormSelect,
   settings,
   isQuantityOrConsumableToolType,
   conditions,
}: OtherProps) => {
   const { Id } = activeValue

   const {
      CustomDate1Enabled,
      CustomDate1Label,
      CustomDate2Enabled,
      CustomDate2Label,
      CustomText1Enabled,
      CustomText1Label,
      CustomText2Enabled,
      CustomText2Label,
      CustomURL1Enabled,
      CustomURL1Label,
      CustomURL2Enabled,
      CustomURL2Label,
      AuditEnabled,
   } = settings

   const [defaultCondition, setDefaultCondition] = useState(
      itemForm.LastAuditCondition
         ? {
              value: itemForm.LastAuditCondition,
              label: itemForm.LastAuditConditionDesc,
           }
         : null
   )

   useEffect(() => {
      updateFormSelect({
         ...itemForm,
         LastAuditCondition: defaultCondition?.value,
         LastAuditConditionDesc: defaultCondition?.label,
      })
   }, [defaultCondition])

   const handleDropdownChange = (
      name: { value: string | number; label: string },
      type: { name: string }
   ) => {
      if (name === null) return
      if (type?.name === 'LastAuditCondition') {
         const { value: rawValue, label } = name
         const value = parseInt(String(rawValue))
         return setDefaultCondition({ value, label })
      }
   }

   return (
      <>
         <div className={styles.itemColumns}>
            <div className={styles.columnOne}>
               <Input
                  id={`${Id}Vendor`}
                  label="Vendor"
                  onChange={(e) =>
                     updateForm('Vendor', e.target.value, itemForm)
                  }
                  value={itemForm.Vendor}
               />

               {!isQuantityOrConsumableToolType ? (
                  <DateInput
                     id={`${Id}WarrantyDate`}
                     label="Warranty Date"
                     onChange={(e) => updateForm('WarrantyDate', e)}
                     selectedDate={parseDate(itemForm?.WarrantyDate)}
                  />
               ) : (
                  <Input
                     id={`${Id}WarrantyDate`}
                     label={'Warranty Date'}
                     value={formatDateForDisplay(itemForm.WarrantyDate) || null}
                     disabled
                  />
               )}

               <Input
                  id={`${Id}WebSiteURL`}
                  onChange={(e) =>
                     updateForm('WebSiteURL', e.target.value, itemForm)
                  }
                  label="Website Url"
                  value={itemForm.WebSiteURL}
               />

               <Input
                  id={`${Id}AttachmentUrl`}
                  onChange={(e) =>
                     updateForm('AttachmentUrl', e.target.value, itemForm)
                  }
                  label="Owners Manual Url"
                  value={itemForm.AttachmentUrl}
               />

               {AuditEnabled && (
                  <>
                     <DateInput
                        id={`${Id}LastAuditDate`}
                        label="Last Audit Date"
                        onChange={(e) => updateForm('LastAuditDate', e)}
                        selectedDate={parseDate(itemForm?.LastAuditDate)}
                     />

                     <DropdownWrapper action={setDefaultCondition} bottomMargin>
                        <Dropdown
                           defaultValue={defaultCondition}
                           isMulti={false}
                           id={`${Id}LastAuditCondition`}
                           name="LastAuditCondition"
                           // @ts-ignore
                           onChange={handleDropdownChange}
                           options={conditions}
                           placeholder="Last Audit Condition"
                           menuPlacement="auto"
                           withWrappers={false}
                        />
                     </DropdownWrapper>
                  </>
               )}

               <Input
                  id={`${Id}ItemId`}
                  label="Item ID"
                  value={itemForm.ItemId}
                  onChange={(e) =>
                     updateForm('ItemId', e.target.value, itemForm)
                  }
               />
            </div>
            <div className={styles.columnTwo}>
               {CustomText1Enabled && (
                  <Input
                     id={`${Id}customField1`}
                     onChange={(e) =>
                        updateForm('CustomText1Value', e.target.value, itemForm)
                     }
                     label={CustomText1Label}
                     value={itemForm.CustomText1Value || null}
                  />
               )}

               {CustomText2Enabled && (
                  <Input
                     id={`${Id}customField2`}
                     onChange={(e) =>
                        updateForm('CustomText2Value', e.target.value, itemForm)
                     }
                     label={CustomText2Label}
                     value={itemForm.CustomText2Value || null}
                  />
               )}

               {CustomDate1Enabled && (
                  <DateInput
                     id={`${Id}customDate1`}
                     onChange={(e) => updateForm('CustomDate1Value', e)}
                     selectedDate={parseDate(itemForm?.CustomDate1Value)}
                     label={CustomDate1Label}
                  />
               )}

               {CustomDate2Enabled && (
                  <DateInput
                     id={`${Id}customDate2`}
                     onChange={(e) =>
                        updateForm('CustomDate2Value', e, itemForm)
                     }
                     selectedDate={parseDate(itemForm?.CustomDate2Value)}
                     label={CustomDate2Label}
                  />
               )}

               {CustomURL1Enabled && (
                  <Input
                     id={`${Id}customUrl1`}
                     onChange={(e) =>
                        updateForm('CustomURL1Value', e.target.value, itemForm)
                     }
                     label={CustomURL1Label}
                     value={itemForm.CustomURL1Value || null}
                  />
               )}

               {CustomURL2Enabled && (
                  <Input
                     id={`${Id}customUrl2`}
                     onChange={(e) =>
                        updateForm('CustomURL2Value', e.target.value, itemForm)
                     }
                     label={CustomURL2Label}
                     value={itemForm.CustomURL2Value || null}
                  />
               )}
            </div>
         </div>
      </>
   )
}

export default memo(Other)
